var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPaginationLast(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12.2 9"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.6 9L0 8.3l3.7-3.8L0 .6.6 0 5 4.5zM7.8 9l-.6-.7 3.7-3.8L7.2.6l.6-.6 4.4 4.5z"
  })));
}

export default "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' version='1.1' viewBox='0 0 12.2 9' xml:space='preserve'%3e %3cpolygon points='0.6 9 0 8.3 3.7 4.5 0 0.6 0.6 0 5 4.5'%3e%3c/polygon%3e %3cpolygon points='7.8 9 7.2 8.3 10.9 4.5 7.2 0.6 7.8 0 12.2 4.5'%3e%3c/polygon%3e %3c/svg%3e";
export { SvgPaginationLast as ReactComponent };